import apiHandler from "../core/apiHandler";

const reportTypeApi = apiHandler('report-types');
export default reportTypeApi;